export default {
    mounted(el, binding) {
        const {duration = '1s', direction = 'fade-in'} = binding.value || {};
        el.style.transition = `all ${duration} ease`;

        if (direction === 'fade-in') {
            el.style.opacity = 0;
            setTimeout(() => {
                el.style.opacity = 1;
            }, 10);
        } else if (direction === 'slide-up') {
            el.style.transform = 'translateY(50px)';
            el.style.opacity = 0;
            setTimeout(() => {
                el.style.transform = 'translateY(0)';
                el.style.opacity = 1;
            }, 10);
        }
    }
}
